"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Alert_1 = __importDefault(require("@material-ui/lab/Alert"));
const Button_1 = __importDefault(require("@material-ui/core/Button"));
const core_1 = require("@material-ui/core");
const styles_1 = __importDefault(require("./styles"));
const ActionAlert = ({ showAlert, message, closeBtnMsg, icon, onClick, severity, variant, }) => {
    const classes = styles_1.default();
    return (react_1.default.createElement(core_1.Grow, { in: showAlert },
        react_1.default.createElement(core_1.Paper, { elevation: 4 },
            react_1.default.createElement(Alert_1.default, { classes: {
                    filledError: classes.filledError,
                    filledSuccess: classes.filledSuccess,
                }, severity: severity || 'success', variant: variant || 'filled', icon: icon || false, onClose: onClick, action: closeBtnMsg ? (react_1.default.createElement(Button_1.default, { color: "inherit", size: "small", onClick: onClick }, closeBtnMsg)) : undefined }, message))));
};
exports.default = ActionAlert;
